import { V1ClinicPaginationResponse } from "../../types/v1_schemas";
import ResultCard from "./ResultCard";
import styled, { CSSProperties } from "styled-components";
import { useTranslation } from "react-i18next";
import RAECard from "./RAECard";
import HCPFCard from "./HCPFCard";
import { useState, useContext } from "react";
import { Grid } from "@trussworks/react-uswds";
import { SurveyTriggerContext } from "../../App";
import { Link, useLocation } from "react-router-dom";
import { CrisisContext } from "../../pages/Search/Search";

type ResultsListProps = {
  clinicPaginationResponse: V1ClinicPaginationResponse,
  zipCode: string,
  selectedResultId?: string;
  isMobile?: boolean;
  showRae: boolean;
};

const DESKTOP_CLASSES = "border-bottom border-base-lighter result-card-inactive";
const DESKTOP_CLASSES_ACTIVE = "border-05 radius-sm border-primary-light result-card-active";
const MOBILE_CLASSES = "border border-base-lighter radius-lg padding-2 margin-bottom-1";

const StyledResultsPagination = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
  margin-left: 2.5rem;
  .spacer {
    margin-left: -3.5rem;
    color: #51534b;
  }
`;

const ResultsList = ({
  clinicPaginationResponse,
  zipCode,
  selectedResultId,
  isMobile = false,
  showRae
}: ResultsListProps) => {
  const { t } = useTranslation();
  const location = useLocation();
 
  let resultsSlice = clinicPaginationResponse.data;

  const totalItems = clinicPaginationResponse.totalCount;
  const firstResult = clinicPaginationResponse.pageNumber === 1 ? 1 : ((clinicPaginationResponse.pageNumber - 1) * clinicPaginationResponse.pageSize) + 1;
  const lastResult = 
    (clinicPaginationResponse.pageNumber === 1 
  ? (clinicPaginationResponse.data.length < clinicPaginationResponse.pageSize ? clinicPaginationResponse.data.length : clinicPaginationResponse.pageSize)
  : (clinicPaginationResponse.pageNumber * clinicPaginationResponse.pageSize > totalItems ? totalItems : clinicPaginationResponse.pageNumber * clinicPaginationResponse.pageSize)) ;

  const [enterCard, setEnterCard] = useState(false);

  // Global application state to track trigger events for showing user
  // option to take site survey
  const { incrementTriggerEventCount } = useContext(SurveyTriggerContext);
  const { crisisSelectedValues } = useContext(CrisisContext);

  return (
    <>
      {showRae ? 
      <RAECard zipCode={zipCode} isMobile={isMobile}></RAECard>
      : <></>}
      <StyledResultsPagination 
      as="div">
      <div>
          {t("paginationHeading", {
            firstResult: firstResult,
            lastResult: lastResult,
            results: totalItems,
          })}
        </div>
        <div className="spacer"></div>

      </StyledResultsPagination>
      
      { location.search &&
        crisisSelectedValues.length > 0 &&
        location.search.includes("page=1") // only in page 1
        ? 
        <div 
            className={
              isMobile
                ? MOBILE_CLASSES
                : DESKTOP_CLASSES
            }
            key='988-line'
          >
          <div className={enterCard ? "padding-y-1 padding-x-5 result-card-hover" : "padding-y-1 padding-x-5 result-card-not-active"}
            role='presentation'
            onMouseEnter={() => {setEnterCard(true) }}
            onMouseLeave={() => {setEnterCard(false) }}
            // Only set id in the desktop list to avoid creating
            // duplicate DOM elements with same id in mobile list
            id={isMobile ? undefined : "988-line"}
          >
            <Grid 
              row
              style={{gap: '1px'}}
              mobile={{ col: true }}
            >
              <div className="display-flex flex-justify" >
                <div className="search-rank" >
                  <span >
                    <img src={require("../../images/phone.png")} alt="" />
                  </span>
                </div>
                <Link
                  onClick={incrementTriggerEventCount}
                  className="usa-link"
                  to='/result/988-line'
                  state={{ prevSearch: location.search,  }}
                  >
                  <h2 className=" margin-top-1 margin-bottom-1" style={{marginLeft: 13}} >{t("988-line")}</h2>
                </Link>
                </div>
            </Grid>
            <div className="display-flex flex-justify" style={{ marginLeft: "60px"}} >
                {t("988-line-description")}
            </div>
          </div>
        </div>
        :
        <></>
        }

      {clinicPaginationResponse.data.length > 0 &&
        resultsSlice.map((result, index) => (
          <>
            <div
              className={
                isMobile
                  ? MOBILE_CLASSES
                  : selectedResultId === result.accountId
                  ? DESKTOP_CLASSES_ACTIVE
                  : DESKTOP_CLASSES
              }
              key={result.accountId}
            >
              <ResultCard data={result} isMobile={isMobile} />
            </div>
            {(!(resultsSlice.length <= 4 && index !== resultsSlice.length - 1) && index === 3) ?
              !isMobile ?
                <div className="hcpf-card-div">
                  <HCPFCard isMobile={isMobile} />
                </div>
              :
                <HCPFCard isMobile={isMobile} />
            : <></>}
          </>
        ))}
    </>
  );
};

export default ResultsList;
